// Also covers mistyped links carrying a payment ID in the site's error fallback.
// Keep this function self-contained: SSR embeds it before loading analytics.
export function isReceiptLocation(location) {
  if (!location) return false;
  return (
    /^\/receipt(?:\/|$)/i.test(location.pathname || "") ||
    new URLSearchParams(location.search || "").has("paymentId")
  );
}
